<template>
  <div class="project-mutate-posts">
    <Posts v-if="isActive" v-bind="$attrs" v-on="$listeners" class="posts--scoped" />
  </div>
</template>

<script>
import Posts from '@/views/Post/Posts'

const meta = {
  skip: true,
}

export { meta }
export default {
  props: {
    isActive: Boolean,
  },
  components: {
    Posts,
  },
}
</script>
